import { render } from "./PersonListComponent.vue?vue&type=template&id=cf8a005e"
import script from "./PersonListComponent.vue?vue&type=script&lang=js"
export * from "./PersonListComponent.vue?vue&type=script&lang=js"

import "./PersonListComponent.vue?vue&type=style&index=0&id=cf8a005e&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__